export default [
    {
        "department_id": 173,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.912594Z",
        "updated_at": "2025-10-23T08:04:20.912606Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Security",
        "description": "Physical and digital security.",
        "type": "user",
        "created_by": null
    },
    {
        "department_id": 172,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.910625Z",
        "updated_at": "2025-10-23T08:04:20.910636Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Design / Creative",
        "description": "Graphic design, UX/UI, product design.",
        "type": "user",
        "created_by": null
    },
    {
        "department_id": 171,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.908699Z",
        "updated_at": "2025-10-23T08:04:20.908745Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Public Relations (PR)",
        "description": "Media handling, public image.",
        "type": "user",
        "created_by": null
    },
    {
        "department_id": 170,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.906639Z",
        "updated_at": "2025-10-23T08:04:20.906650Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Logistics & Supply Chain",
        "description": "Warehousing, transportation, delivery.",
        "type": "user",
        "created_by": null
    },
    {
        "department_id": 169,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.904856Z",
        "updated_at": "2025-10-23T08:04:20.904868Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Training & Development",
        "description": "Employee skill development programs.",
        "type": "user",
        "created_by": null
    },
    {
        "department_id": 168,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.902704Z",
        "updated_at": "2025-10-23T08:04:20.902716Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Production / Manufacturing",
        "description": "Factory operations, assembly lines.",
        "type": "user",
        "created_by": null
    },
    {
        "department_id": 167,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.900960Z",
        "updated_at": "2025-10-23T08:04:20.900972Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Quality Assurance (QA)",
        "description": "Testing, quality checks, audits.",
        "type": "user",
        "created_by": null
    },
    {
        "department_id": 166,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.898602Z",
        "updated_at": "2025-10-23T08:04:20.898615Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Procurement / Purchase",
        "description": "Vendor management, purchasing goods/services.",
        "type": "user",
        "created_by": null
    },
    {
        "department_id": 165,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.896377Z",
        "updated_at": "2025-10-23T08:04:20.896388Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Legal & Compliance",
        "description": "Contracts, laws, regulatory compliance.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 164,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.894329Z",
        "updated_at": "2025-10-23T08:04:20.894340Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Research & Development (R&D)",
        "description": "Innovation, product improvement.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 163,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.892070Z",
        "updated_at": "2025-10-23T08:04:20.892082Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Administration",
        "description": "Office management, facility services.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 162,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.890169Z",
        "updated_at": "2025-10-23T08:04:20.890181Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Customer Support / Service",
        "description": "Post-sales customer handling.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 161,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.888242Z",
        "updated_at": "2025-10-23T08:04:20.888254Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Information Technology (IT)",
        "description": "Software, hardware, infrastructure.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 160,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.886569Z",
        "updated_at": "2025-10-23T08:04:20.886580Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Operations",
        "description": "Day-to-day business activities.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 159,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.884604Z",
        "updated_at": "2025-10-23T08:04:20.884615Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Marketing",
        "description": "Advertising, brand management, campaigns.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 158,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.882445Z",
        "updated_at": "2025-10-23T08:04:20.882457Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Sales",
        "description": "Direct sales, business development.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 157,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.880561Z",
        "updated_at": "2025-10-23T08:04:20.880573Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Finance & Accounts",
        "description": "Accounting, budgeting, compliance.",
        "type": "system",
        "created_by": null
    },
    {
        "department_id": 156,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-23T08:04:20.877863Z",
        "updated_at": "2025-10-23T08:04:20.877874Z",
        "archived_at": null,
        "deleted_at": null,
        "created_by_name": null,
        "name": "Human Resources (HR)",
        "description": "Recruitment, payroll, employee relations.",
        "type": "system",
        "created_by": null
    }
]